import type { PageSectionProps } from '../types/layout';

const PageSection = ({
  title,
  description,
  actions,
  children,
  className = '',
  bodyClassName = '',
}: PageSectionProps) => {
  return (
    <section className={`card app-surface ${className}`.trim()}>
      {(title || description || actions) && (
        <div className="card-header app-surface__header">
          <div className="app-section-header">
            <div className="app-section-header__copy">
              {title && <h3 className="card-title app-section-title">{title}</h3>}
              {description && <div className="app-section-description">{description}</div>}
            </div>
            {actions && <div className="btn-list app-section-actions">{actions}</div>}
          </div>
        </div>
      )}
      <div className={`card-body ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
};

export default PageSection;
